<template>
    <div>
        <Navigation/>
        <MessageSection/>
        <Footer/>
    </div>
</template>

<script>
import Navigation from './Navigation.vue';
import MessageSection from './MessageSection.vue';
import Footer from './footer.vue'
export default {
    components:{
        Navigation,
        MessageSection,
        Footer
    }
}
</script>
<style scoped>

</style>